import { TeamStatsHeader } from 'components/base/team-stats-header';
import React, { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  loading?: boolean;
};

const TeamStatsLayout: FC<Props> = ({
  children,
  className = '',
  headerClassName = '',
  loading
}) => {
  return (
    <div className='min-h-screen flex flex-col'>
      <div className={headerClassName}>
        <TeamStatsHeader />
      </div>
      <main className='grow flex flex-col'>
        <div
          className={`grow container flex flex-col max-sm:px-4 mx-auto py-8 md:pt-10 ${className}`}>
          {loading ? (
            <div className='flex juatify-center'>
              <p>Loading...</p>
            </div>
          ) : (
            children
          )}
        </div>
      </main>
    </div>
  );
};
export default TeamStatsLayout;
